import { Link } from 'react-router-dom';
import { coursesData } from '@/mocks/home';

export default function CoursesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">热门培训课程</h2>
            <p className="text-foreground-600 text-base">精选优质课程，助您快速提升运动技能</p>
          </div>
          <Link
            to="/category/training"
            className="flex items-center gap-1.5 text-primary-600 font-medium text-sm whitespace-nowrap hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部课程 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {coursesData.map((course) => (
            <Link
              key={course.id}
              to={`/article/${course.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                  {course.category}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2">{course.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-bar-chart-horizontal-line"></i> {course.level}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {course.duration}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-heading text-lg font-bold text-primary-600">
                    ¥{course.price.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1 text-foreground-500 text-xs">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {course.rating} ({course.students})
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}